import { JSX, ParentProps, createEffect, createMemo, onMount } from 'solid-js'
import { BeforeLeaveHandler, requireStepContext, requireWizardContext, StepContext, WizardContext, WizardContextJsx } from './WizardContext'
import styles from './st-wizard.module.css'
import { Step } from './partials/Step'
import { Header } from './partials/Header'
import { Button } from './partials/Button'
import { ControlPanel } from './partials/ControlPanel'
import Flexbox from '../st-flexbox/st-flexbox'

export { requireWizardContext, requireStepContext }

export class WizardProps {
    size?: 'small' | 'medium' = 'medium';
    initialStep?: number;
    onComplete?= () => { };
    onCancel?= () => { };
}

export default function Wizard(props: ParentProps<WizardProps> & JSX.HTMLAttributes<HTMLDivElement>) {
    const context = new WizardContext(props.onComplete, props.onCancel, createMemo(() => props.size ?? 'medium'), props.initialStep);

    return (
        <WizardContextJsx.Provider value={context}>
            <WizardInternal {...props} />
        </WizardContextJsx.Provider>
    )
}

function WizardInternal(props: ParentProps<WizardProps> & JSX.HTMLAttributes<HTMLDivElement>) {
    const ctx = requireWizardContext();
    const {
        onComplete: onComplete,
        class: userClass,
        style: userStyle,
        children,
        ...divProps
    } = props

    const mergedClass = [
        styles['st-wizard'],
        userClass
    ].filter(Boolean).join(' ')

    onMount(async () => {
        // const data = await api.Load();
    })

    function initStepContainer(el: HTMLDivElement) {
        createEffect(() => {
            const step = ctx.currStep();
            requestAnimationFrame(() => {
                const minHeight = parseFloat(el.style.minHeight) || 0;
                el.style.minHeight = '';

                const rect = el.getBoundingClientRect();
                if (minHeight < rect.height) {
                    el.style.minHeight = `${rect.height}px`;
                }
                else {
                    el.style.minHeight = `${minHeight}px`;
                }
            });
        });
    }

    return (
        <div class={mergedClass} {...divProps} data-size={ctx.size()} >
            <Header />
            <Flexbox ref={initStepContainer} dir="horizontal" auto>
                {props.children}
            </Flexbox>
            <ControlPanel />
        </div>
    );
}

Wizard.Step = Step;
Wizard.Button = Button;

Wizard.defaultProps = new WizardProps();
